export interface ThemeFormGroup {
  label: string;
  fields: { key: string; label: string; isColor: boolean }[];
}

export const THEME_FORM_GROUPS: ThemeFormGroup[] = [
  {
    label: 'Фон и поверхности',
    fields: [
      { key: '--bg', label: 'Фон страницы', isColor: true },
      { key: '--surface', label: 'Поверхность', isColor: true },
      { key: '--surface2', label: 'Поверхность 2', isColor: true },
      { key: '--border', label: 'Граница', isColor: true },
    ],
  },
  {
    label: 'Текст',
    fields: [
      { key: '--text', label: 'Основной', isColor: true },
      { key: '--text2', label: 'Вторичный', isColor: true },
      { key: '--text3', label: 'Третичный', isColor: true },
    ],
  },
  {
    label: 'Акцентный цвет',
    fields: [
      { key: '--orange', label: 'Акцент', isColor: true },
      { key: '--orange-light', label: 'Светлый фон', isColor: true },
      { key: '--orange-dark', label: 'Тёмный акцент', isColor: true },
      { key: '--og', label: 'Градиент кнопок', isColor: false },
    ],
  },
  {
    label: 'Статусные цвета',
    fields: [
      { key: '--green', label: 'Зелёный', isColor: true },
      { key: '--green-light', label: 'Зелёный фон', isColor: true },
      { key: '--red', label: 'Красный', isColor: true },
      { key: '--red-light', label: 'Красный фон', isColor: true },
      { key: '--blue', label: 'Синий', isColor: true },
      { key: '--blue-light', label: 'Синий фон', isColor: true },
      { key: '--purple', label: 'Фиолетовый', isColor: true },
      { key: '--purple-light', label: 'Фиолетовый фон', isColor: true },
    ],
  },
  {
    label: 'Скругления',
    fields: [
      { key: '--r', label: 'Большое (карточки)', isColor: false },
      { key: '--r-sm', label: 'Среднее (кнопки)', isColor: false },
      { key: '--r-xs', label: 'Малое', isColor: false },
    ],
  },
  {
    label: 'Тени',
    fields: [
      { key: '--sh', label: 'Обычная', isColor: false },
      { key: '--sh-lg', label: 'Большая', isColor: false },
    ],
  },
];
